import { Link } from "react-router-dom";
import { openCookieBanner } from "./CookieBanner";

export default function LegalFooter({ dark = false }) {
  const linkCls = dark ? "text-white/70 hover:text-white" : "text-muted-foreground hover:text-foreground";
  return (
    <div className={`text-xs ${dark ? "text-white/60" : "text-muted-foreground"} flex flex-wrap gap-x-4 gap-y-2 justify-center items-center`} data-testid="legal-footer">
      <Link to="/aviso-legal" className={linkCls}>Aviso legal</Link>
      <span className="opacity-30">·</span>
      <Link to="/privacidad" className={linkCls}>Política de privacidad</Link>
      <span className="opacity-30">·</span>
      <Link to="/politica-cookies" className={linkCls}>Cookies</Link>
      <span className="opacity-30">·</span>
      <Link to="/terminos" className={linkCls}>Términos</Link>
      <span className="opacity-30">·</span>
      <Link to="/consentimiento" className={linkCls}>Consentimiento</Link>
      <span className="opacity-30">·</span>
      <Link to="/uso-ia" className={linkCls}>Uso de IA</Link>
      <span className="opacity-30">·</span>
      <button
        type="button"
        onClick={openCookieBanner}
        className={`${linkCls} underline-offset-2 hover:underline`}
        data-testid="footer-manage-cookies"
      >
        Gestionar cookies
      </button>
    </div>
  );
}
